import { isTableMetricReportEditorSchema } from 'reporting-data/tsTypes/editorTypes';
import { List as ImmutableList, fromJS } from 'immutable';
import { fromMetricKey, toMetricKey } from 'reporting-data/v2/dataset/datasetMetrics';
import { getMetricsFromConfig } from 'reporting-data/report/configReportGetters';
export const getMetricsFromSelectedTableMetricValues = report => {
  const reportEditors = report.get('editors');
  if (!reportEditors) {
    return ImmutableList();
  }
  const tableMetricsSchema = reportEditors.find(schema => isTableMetricReportEditorSchema(schema.toJS()));
  const selectedTableMetricStrings = tableMetricsSchema ? tableMetricsSchema.get('selectedMetrics', []) : [];
  return ImmutableList(selectedTableMetricStrings.map(metric => {
    const {
      property,
      type
    } = fromMetricKey(metric);
    return fromJS({
      property,
      metricTypes: [type]
    });
  }));
};
export const getMetricKeysFromReportConfig = config => getMetricsFromConfig(config).map(metric => {
  const metricTypes = metric.get('metricTypes');
  return toMetricKey({
    property: metric.get('property'),
    type: metricTypes ? metricTypes.get(0) : undefined
  });
}).toArray();